import template from './labor-expense-cost-breakdown-modal.html';
import controller from './labor-expense-cost-breakdown-modal.controller';

const LaborExpenseCostBreakdownModalConfig = {
  animation: true,
  template,
  controller,
  controllerAs: '$ctrl',
  size: 'lg',
  backdrop: true,
  windowClass: 'hmodal-info animated fadeIn labor-expense-cost-breakdown-modal'
};

export default LaborExpenseCostBreakdownModalConfig;



// WEBPACK FOOTER //
// ./client/pages/admin/reports/canned-reports/labor-distribution-report/modals/labor-expense-cost-breakdown-modal/labor-expense-cost-breakdown-modal.component.js